function TwitterIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" color="inherit">
      <g id="TypeIcon" color="inherit">
        <path id="Vector 49 (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M4.53371 4.5L17.367 21H19.4667L6.63341 4.5H4.53371ZM3.16139 5.17882C2.47168 4.29206 3.10361 3 4.22701 3H6.70678C7.12337 3 7.51664 3.19234 7.7724 3.52118L20.8391 20.3212C21.5288 21.2079 20.8968 22.5 19.7734 22.5H17.2937C16.8771 22.5 16.4838 22.3077 16.2281 21.9788L3.16139 5.17882Z" fill="currentColor" fillOpacity="0.7" />
        <path id="Vector 50 (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M20.4983 3.18945C20.1887 2.91426 19.7146 2.94215 19.4394 3.25174L3.43944 21.2517C3.16425 21.5613 3.19213 22.0354 3.50172 22.3106C3.81131 22.5858 4.28536 22.5579 4.56055 22.2483L20.5605 4.24828C20.8357 3.93869 20.8079 3.46464 20.4983 3.18945Z" fill="currentColor" fillOpacity="0.7" />
      </g>
    </svg>
  )
}

export default TwitterIcon;
